// ABOUTME: Displays called bingo squares as a grid of bingo balls.
// ABOUTME: Shows 5 balls per row, wrapping to additional rows as needed.
import Typography from '@mui/material/Typography'
import { BingoBallGrid, BingoBall } from '../theme'

interface Props {
  squares: { id: string; title: string }[]
}

export function CalledSquareBalls({ squares }: Props) {
  if (squares.length === 0) return null
  return (
    <BingoBallGrid>
      {squares.map((sq) => (
        <BingoBall key={sq.id} called>
          <Typography variant="caption" lineHeight={1.2}>{sq.title}</Typography>
        </BingoBall>
      ))}
    </BingoBallGrid>
  )
}
